import './OldPlayerInviteModal.scss'

import Dropdown, { closeDropdownEvent } from '../../../components/Dropdown/Dropdown'
import { ERROR, READY, RELOADING, useVisualState } from '../../../hooks/useVisualState'
import React, { useCallback, useState } from 'react'
import { oldGet, oldPost } from '../../../helpers/requestOld'

import Avatar from '../../../components/Avatar/Avatar'
import Button from '../../../components/Button/Button'
import GenericErrorModal from '../../../modules/GenericErrorModal/GenericErrorModal'
import Modal from '../../../components/Modal/Modal'
import ModalContent from '../../../components/Modal/ModalContent'
import ModalFooter from '../../../components/Modal/ModalFooter'
import ModalHeader from '../../../components/Modal/ModalHeader'
import TextField from '../../../components/TextField/TextField'
import t from '../../../helpers/i18n'
import { useParams } from 'react-router-dom'

const isValid = (value) => {
  if (!value || value.length === 0) {
    return false
  } else {
    const parts = value.trim().split(/\s+/)
    return parts.some(value => value.length >= 3)
  }
}

const OldPlayerInviteModal = ({ onCloseRequested }) => {
  const [[, results], setResults] = useVisualState()
  const [player, setPlayer] = useState()
  const [error, setError] = useState()
  const { teamId } = useParams()

  const handleInvitePlayer = useCallback(() => {
    if (!player) return
    const data = {
      team_id: teamId,
      player_id: player.player_id
    }
    oldPost('/delegate/teams/' + teamId + '/players/' + player.player_id + '/invite', data)
      .then(() => onCloseRequested())
      .catch(error => {
        setError(error)
      })
  }, [onCloseRequested, player, teamId])

  const handleSelectPlayer = useCallback((event, player) => {
    setPlayer(player)
    event.currentTarget.dispatchEvent(closeDropdownEvent())
  }, [])

  const handleValidate = useCallback((query) => {
    return new Promise((resolve, reject) => {
      if (!isValid(query)) return reject()
      setResults(RELOADING)
      oldGet('/players/search?query=' + encodeURIComponent(query))
        .then(response => {
          setResults(READY, response)
          resolve()
        })
        .catch(error => {
          reject('Invalid query')
          setResults(ERROR)
          console.error(error)
        })
    })
  }, [setResults])

  return (
    <div className="old-player-invite-modal">
      <Modal onCloseRequested={onCloseRequested}>
        <ModalHeader title={t('modal_headers.Invite_member')} />
        <ModalContent>
          <Dropdown
            button={<SearchInput onValidation={handleValidate} />}
            open={!!results}
            grow
            scroll
            basic
          >
            {results && results.map(player =>
              <div key={player.player_id} className="-player" onClick={(event) => handleSelectPlayer(event, player)}>
                <div className="-avatar"><Avatar size="large" source={player.avatar} alternative={player.name} /></div>
                <div className="-data">
                  <div className="proper-noun-large-semibold">{player.name}</div>
                  {player.email &&
                    <div className="-entry">
                      <div className="-label label-small-basic">{t('labels.Email')}</div>
                      <div className="label-small-basic">{player.email}</div>
                    </div>
                  }
                  {player.mobile &&
                    <div className="-entry">
                      <div className="-label label-small-basic">{t('labels.Mobile')}</div>
                      <div className="label-small-basic">{player.mobile}</div>
                    </div>
                  }
                  {player.birth_date &&
                    <div className="-entry">
                      <div className="-label label-small-basic">{t('labels.Birthdate')}</div>
                      <div className="label-small-basic">{player.birth_date}</div>
                    </div>
                  }
                </div>
              </div>
            )}
            {results && results.length === 0 &&
              <div className="-not-found label-small-basic">{t('There are no coincidences')}</div>
            }
          </Dropdown>
        </ModalContent>
        {player &&
          <ModalContent>
            <div className="-player">
              <div className="-avatar"><Avatar size="large" source={player.avatar} alternative={player.name} /></div>
              <div className="-data">
                <div className="proper-noun-large-semibold">{player.name}</div>
                {player.email &&
                  <div className="-entry">
                    <div className="-label label-small-basic">{t('labels.Email')}</div>
                    <div className="label-small-basic">{player.email}</div>
                  </div>
                }
                {player.mobile &&
                  <div className="-entry">
                    <div className="-label label-small-basic">{t('labels.Mobile')}</div>
                    <div className="label-small-basic">{player.mobile}</div>
                  </div>
                }
                {player.birth_date &&
                  <div className="-entry">
                    <div className="-label label-small-basic">{t('labels.Birthdate')}</div>
                    <div className="label-small-basic">{player.birth_date}</div>
                  </div>
                }
              </div>
            </div>
          </ModalContent>
        }
        <ModalFooter>
          <Button grow onClick={handleInvitePlayer} label={t("buttons.Invite_player")} type="dark" color="green" />
        </ModalFooter>

        {error && <GenericErrorModal error={error} i18nPrefix="OldPlayerInviteModal" onCloseRequested={() => setError(false)} />}
      </Modal>
    </div>
  )
}

const SearchInput = ({ onValidation }) => {
  return (
    <TextField
      name="query"
      label={t("labels.Search_for_players_by_name_email_or_mobile_number")}
      placeholder={t("placeholders.Search_term")}
      autoComplete="off"
      onValidation={onValidation}
    />
  )
}

export default OldPlayerInviteModal